import Icon from "../../../components/AppIcon";
import { CollaborationType } from "../types";

interface CollaborationTypeCardProps {
  type: CollaborationType;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const CollaborationTypeCard = ({
  type,
  isSelected,
  onSelect,
}: CollaborationTypeCardProps) => {
  return (
    <button
      onClick={() => onSelect(type.id)}
      className={`w-full p-6 rounded-lg border-2 transition-all duration-300 text-left ${
        isSelected
          ? "border-primary bg-primary/10 shadow-elevation-2"
          : "border-border bg-surface hover:border-primary/50 hover:shadow-elevation-1"
      }`}
    >
      <div className="flex items-start gap-4">
        <div
          className={`p-3 rounded-lg ${
            isSelected ? "bg-primary text-primary-foreground" : "bg-muted"
          }`}
        >
          <Icon name={type.icon} size={24} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">
            {type.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            {type.description}
          </p>
          <div className="space-y-2">
            {type.benefits.map((benefit, index) => (
              <div key={index} className="flex items-center gap-2">
                <Icon
                  name="Check"
                  size={16}
                  color={isSelected ? "var(--color-primary)" : "var(--color-muted-foreground)"}
                />
                <span className="text-sm text-muted-foreground">{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </button>
  );
};

export default CollaborationTypeCard;